export const TRIAL_RATE_LIMIT = 20;
export const SUBSCRIBED_RATE_LIMIT = 400;
export const TRIAL_DURATION_DAYS = 7;

export type UserTier = 'subscribed' | 'trial-active' | 'trial-expired';

export interface TrialProfile {
  subscribed: boolean;
  trial_expires_at: string | null;
}

export function computeUserTier(profile: TrialProfile): UserTier {
  if (profile.subscribed) return 'subscribed';
  if (profile.trial_expires_at) {
    const expires = new Date(profile.trial_expires_at);
    if (expires > new Date()) return 'trial-active';
  }
  return 'trial-expired';
}

export function getRateLimit(tier: UserTier): number {
  if (tier === 'subscribed') return SUBSCRIBED_RATE_LIMIT;
  if (tier === 'trial-active') return TRIAL_RATE_LIMIT;
  return 0;
}
